export const NOTIFICATION_SUCCESS = 'GET_SITES';
export const GET_NOTIFICATION = 'GET_NOTIFICATION';